import { createSelector,createSlice } from '@reduxjs/toolkit';

const initialState: IInventoryState = {
  data: [],
  selected: [],
  requested: false,
  filters: {
    models: {},
    makes: {},
  },
  filtersRequested: false,
  filtersSelected: {},
  featuredFilters: {
    expiring: null,
    featured: null,
    noVin: null,
    noPrice: null,
    noPictures: null,
    ongoingDeal: null,
  },
  uploadImageProgress: null,
  multipleUploadImageProgress: [],
};

export const inventorySlice = createSlice({
  name: 'inventory',
  initialState,
  reducers: {
    setSelectedFilters(state, { payload }) {
      return { ...state, filtersSelected: payload };
    },
    setInventory(state, { payload }) {
      return { ...state, data: payload?.data, meta: payload?.meta };
    },
    setFilters(state, { payload }) {
      return { ...state, filters: payload?.data };
    },
    setSearchParams(state, { payload }) {
      return { ...state, searchParams: payload };
    },
    setFeaturedFilters(state, { payload }) {
      return { ...state, featuredFilters: payload };
    },
    setUploadImageProgress(state, { payload }) {
      return { ...state, uploadImageProgress: payload };
    },
    setMultipleUploadImageProgress(state, { payload }) {
      return { ...state, multipleUploadImageProgress: payload };
    },
  },
});

export const {
  setSelectedFilters,
  setInventory,
  setFilters,
  setSearchParams,
  setFeaturedFilters,
  setUploadImageProgress,
  setMultipleUploadImageProgress,
} = inventorySlice.actions;

export const getInventory = (state: IReducerStates) => state.inventory;

// Memoized selectors to prevent unnecessary re-renders
export const getInventoryData = createSelector(
  [getInventory],
  (inventory) => inventory.data
);

export const getInventoryFilters = createSelector(
  [getInventory],
  (inventory) => inventory.filtersSelected
);

export const getInventoryMeta = createSelector(
  [getInventory],
  (inventory) => inventory.meta
);

export const getFeaturedFilters = createSelector(
  [getInventory],
  (inventory) => inventory.featuredFilters
);

// Combined selector for commonly used data
export const getInventoryState = createSelector(
  [getInventoryData, getInventoryFilters, getInventoryMeta, getFeaturedFilters],
  (data, filters, meta, featuredFilters) => ({
    data,
    filters,
    meta,
    featuredFilters,
  })
);
